module.exports = __webpack_public_path__ + "static/media/6.632fb4ed.JPG";